import { render, staticRenderFns } from "./LeaderIntroduce.vue?vue&type=template&id=2b30b2a3&scoped=true&"
import script from "./LeaderIntroduce.vue?vue&type=script&lang=js&"
export * from "./LeaderIntroduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b30b2a3",
  null
  
)

export default component.exports